module.exports = __webpack_public_path__ + "img/avatar.d6c29782.png";